<style lang="scss" scoped>
.adminCheckCode {
  height: 100%;
  //   width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
}
</style>
<template>
  <div class="adminCheckCode">
    <base-admin-nav></base-admin-nav>
  <router-view>

  </router-view>
  </div>

</template>
<script>
import BaseAdminNav from '@/components/BaseAdminNav.vue';

  export default {
    data() { return {}; },
    methods: {},
    components: {
      BaseAdminNav,
    },
    created() {},
    mounted() {},
    props: {},
    watch: {},
  };
</script>
